import restapi from 'shared-module/api/restapi'
import commerceSelector, { eCommerceTokenID } from 'ecommerce-module/core/eCommerce.selectors'
import eCommerceBuilder from 'ecommerce-module/api/eCommerce.builder'

const authenticate = () =>
  restapi
    .post('/api/v3/commerce/user/token', null, {
      withCredentials: true,
    })
    .then((response) => response.data)

const refreshToken = (commerceRefreshToken) =>
  restapi
    .post(
      '/api/v3/commerce/user/token/refresh',
      { commerce_refresh_token: commerceRefreshToken },
      {
        withCredentials: true,
      },
    )
    .then((response) => response.data)

const retryRequest = async (requestFn, retries = 3) => {
  try {
    return await requestFn()
  } catch (error) {
    if (retries > 0) {
      console.warn(`Retrying request... Attempts left: ${retries}`)
      return retryRequest(requestFn, retries - 1)
    } else {
      console.error('Failed to complete request after multiple attempts:', error)
      throw error
    }
  }
}

const fetchInsidersClubProduct = () => restapi
  .get(
    `/api/v3/commerce/products?ids=${commerceSelector.salesForceInsidersClub}`, {
      headers: { 'x-commerce-token': localStorage.getItem(eCommerceTokenID) },
    })
  .then(response => response.data.data)
  .catch(error => error)

const fetchPlans = () => retryRequest(() =>
  restapi.get(
    `/api/v3/commerce/products?ids=${commerceSelector.salesForcePlansIds}`, {
      headers: { 'x-commerce-token': localStorage.getItem(eCommerceTokenID) },
    })
    .then(response => response.data.data.map(plan => eCommerceBuilder.buildECommerceAddons(plan))),
)

const fetchProducts = (retries = 3) =>
  retryRequest(() =>
    restapi.get(
      '/api/v3/commerce/products?ids=D06121,D06131,D06141,D06120,D06130,D06140',
      {
        headers: { 'x-commerce-token': localStorage.getItem(eCommerceTokenID) },
      },
    )
      .then(response => response.data.data.map(addon => eCommerceBuilder.buildECommercePlans(addon)))
  , retries)
    .catch(() => []) // Return empty array on failure

const getFirstBasketId = (basketId) => {
  if (basketId) {
    return basketId.split(',')[0]
  }
  return null // Retourne null si basketId est manquant
}
const createBasket = () =>
  restapi.post(
    '/api/v3/commerce/baskets', {}, {
      headers: { 'x-commerce-token': localStorage.getItem(eCommerceTokenID) },
    })
    .then(response => response?.data?.data?.map(basket => eCommerceBuilder.buildBaskets(basket))).catch(error => {
      if (error.response && error.response.data.basketIds) {
        const basketId = getFirstBasketId(error.response.data.basketIds)
        localStorage.setItem('basketId', basketId)
        return getBasket(basketId).then(basket => basket)
      } else {
        console.error('An error occurred:', error.message)
        throw error
      }
    })

const getBasket = (basketId) => retryRequest(() =>
  restapi.get(`/api/v3/commerce/baskets/${basketId}`, {
    headers: { 'x-commerce-token': localStorage.getItem(eCommerceTokenID) },
  })
    .then(response => response.data),
)

const addItemToBasket = (basketId, itemDataList) => {
  const token = localStorage.getItem(eCommerceTokenID)

  const requestBody = itemDataList.map(item => ({
    itemId: item.itemId,
    productId: item.productId,
    productName: item.cameraName,
    quantity: item.quantity || 1,
    c_cameraId: item.cameraId,
    c_cameraName: item.cameraName,
    c_subscribeProId: item?.subscribeProId,
    c_InsiderclubMember: item?.insiderclubMember,
  }))

  return retryRequest(() =>
    restapi.post(
      `/api/v3/commerce/baskets/${basketId}/items`,
      requestBody,
      {
        headers: { 'x-commerce-token': token },
      },
    )
      .then(response => response.data),
  )
}

const updateBasketItem = (basketId, itemDataList) => {
  const token = localStorage.getItem(eCommerceTokenID)

  const requestBody = itemDataList.map(item => ({
    itemId: item.itemId,
    product_id: item.productId,
    quantity: item.quantity,
    c_InsiderclubMember: item?.insiderclubMember,
  }))

  return retryRequest(() =>
    restapi.patch(
      `/api/v3/commerce/baskets/${basketId}/items`,
      requestBody,
      {
        headers: { 'x-commerce-token': token },
      },
    )
      .then(response => response.data),
  )
}

const deleteItemFromBasket = (basketId, itemId) => {
  return restapi
    .delete(`/api/v3/commerce/baskets/${basketId}/items/${itemId}`, {
      headers: { 'x-commerce-token': localStorage.getItem(eCommerceTokenID) },
    })
    .then(response => response.data)
    .catch(error => {
      return error
    })
}

const eCommerceApi = { authenticate, fetchPlans, fetchProducts, createBasket, getBasket, addItemToBasket, updateBasketItem, fetchInsidersClubProduct, deleteItemFromBasket, refreshToken }
export default eCommerceApi
